let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ikegb")).then(() => parcelRequire('6Gbpp'));